import { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import useFilterManagerWithState from '@/components/FilterManager/useFilterManagerWithState';
import { UserCollectionFragment } from '@/modules/corporate/modules/group/views/GroupManager/graphql/fragments/generated/UserCollection';
import useGroups from '@/modules/corporate/modules/group/views/GroupManager/hooks/useGroups';
import {
  getSortAndFilterItems,
  GROUP_SORT_DEFAULT_VALUE,
} from '@/modules/corporate/modules/group/views/GroupManager/utils';

import { GROUP_DEFAULT_FILTERS } from '../../../LearnerAndGroupDialog/utils';

type UseGroupsProps = {
  userGroupIds: string[];
};

export default function useSeeAllGroups(props: UseGroupsProps) {
  const { t } = useTranslation();
  const { userGroupIds } = props;
  const filterManager = useFilterManagerWithState({});
  const {
    state: { sort, filter, search },
  } = filterManager;

  const sortAndFilterItems = useMemo(() => getSortAndFilterItems(t), [t]);

  const {
    groups,
    isFetching,
    totalCount = 0,
    fetchMore,
  } = useGroups({
    filters: {
      ...filter,
      ids: userGroupIds,
      name: search,
      ...GROUP_DEFAULT_FILTERS,
    },
    sort: sort.length ? sort : GROUP_SORT_DEFAULT_VALUE,
    pause: !userGroupIds.length,
  });

  return {
    data: groups as UserCollectionFragment[],
    isFetching,
    totalCount,
    sortAndFilterItems,
    filterManager,
    fetchMore,
  };
}
